import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class AiCostLimitUserView {
	readonly id: number;
	readonly fullName: string;
	readonly isActive: boolean;

	constructor(payload: UserPayload) {
		this.id = payload.id;
		this.fullName = `${payload.firstName} ${payload.lastName}`;
		this.isActive = payload.isActive;

		Object.freeze(this);
	}
}

export default AiCostLimitUserView;
